/* unplugin-vue-components disabled */import { render } from "./IfasCard.vue?vue&type=template&id=6bfd7fda&scoped=true"
import script from "./IfasCard.vue?vue&type=script&lang=js"
export * from "./IfasCard.vue?vue&type=script&lang=js"

import "./IfasCard.vue?vue&type=style&index=0&id=6bfd7fda&lang=css"
import "./IfasCard.vue?vue&type=style&index=1&id=6bfd7fda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfd7fda"]])

export default __exports__